export default "__VITE_ASSET__DkFd8U0F__"